import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AccountImapService {
  private apiUrl = environment.apiURL + 'account-imap';

  constructor(private http: HttpClient) {}

  getConfig(): Observable<any> {
    return this.http.get(this.apiUrl);
  }

  createConfig(body: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/new`, body);
  }

  updateConfig(body: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/update`, body);
  }

  deleteConfig(): Observable<any> {
    return this.http.delete(`${this.apiUrl}/delete`);
  }

  testConnection(body: any = {}): Observable<any> {
    return this.http.post(`${this.apiUrl}/test-connection`, body);
  }
}
